module.exports = __webpack_public_path__ + "img/final_score_field.87c770c6.jpg";